import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, List, ListItem } from "@mui/material";

const BlockListError = (props) => {
    const getData = (item) => {
        return Object.values(item).toString().replace(",,", ", --- , ");
    };

    return (
        <Dialog open={true} fullWidth>
            <ModalStyle property={String(false)}>
                <DialogTitle>Error en carga masiva</DialogTitle>

                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            Los siguientes registros no cumplen con el formato
                            requerido, por favor valida e intenta nuevamente.
                            <hr />
                        </Grid>
                        {props.content.length > 0 && (
                            <List>
                                <Grid item xs={12}>
                                    {props.content.map((item, key) => {
                                        return (
                                            <ListItem key={key}>
                                                {typeof item === "string" ? item : getData(item)}
                                            </ListItem>
                                        );
                                    })}
                                </Grid>
                            </List>
                        )}
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" onClick={closelightbox}>
                        Entendido
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default BlockListError;
